import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import MailOutline from "@material-ui/icons/MailOutline";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import View from "./View";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function Delete(props) {
  const source = useRef(new AbortController());
  const { id } = useParams();

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const [terminalFee, setTerminalFee] = React.useState(null);
  const [redirect, setRedirect] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  useEffect(() => {
    bookingApi
      .get("/TerminalFees/" + id, {
        signal: source.current.signal
      })
      .then(data => setTerminalFee(data))
      .catch(error => console.log(error));
  }, [id]);

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .delete("/TerminalFees/" + id, {
        signal: source.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to="/admin/TerminalFees/List" />
  ) : (
    terminalFee !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>DELETE TERMINAL FEE</h4>
            </CardHeader>
            <CardBody>
              <i>*Are you sure to delete this Terminal Fee?</i>
              <form onSubmit={handleSubmit}>
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  CANCEL
                </Button>
                <Button disabled={disabled} color="rose" type="submit">
                  DELETE
                </Button>
              </form>
              <View terminalFee={terminalFee} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  );
}

Delete.propTypes = {
  history: PropTypes.object
};
